/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Backup_Save_Settings_LabelInputs */

const en_options_backup_save_settings_label = /** @type {(inputs: Options_Backup_Save_Settings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save automatic backup settings`)
};

const fr_options_backup_save_settings_label = /** @type {(inputs: Options_Backup_Save_Settings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer les paramètres de sauvegarde automatique`)
};

const de_options_backup_save_settings_label = /** @type {(inputs: Options_Backup_Save_Settings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatische Sicherungseinstellungen speichern`)
};

const it_options_backup_save_settings_label = /** @type {(inputs: Options_Backup_Save_Settings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva le impostazioni di backup automatico`)
};

const ru_options_backup_save_settings_label = /** @type {(inputs: Options_Backup_Save_Settings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохранение настроек автоматического резервного копирования`)
};

const es_options_backup_save_settings_label = /** @type {(inputs: Options_Backup_Save_Settings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar la configuración de copia de seguridad automática`)
};

const zh_cn2_options_backup_save_settings_label = /** @type {(inputs: Options_Backup_Save_Settings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存自动备份设置`)
};

const ja_options_backup_save_settings_label = /** @type {(inputs: Options_Backup_Save_Settings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動バックアップ設定を保存する`)
};

const hi_options_backup_save_settings_label = /** @type {(inputs: Options_Backup_Save_Settings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वचालित बैकअप सेटिंग्स सहेजें`)
};

const pt_pt2_options_backup_save_settings_label = /** @type {(inputs: Options_Backup_Save_Settings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar configurações de backup automático`)
};

/**
* | output |
* | --- |
* | "Save automatic backup settings" |
*
* @param {Options_Backup_Save_Settings_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_backup_save_settings_label = /** @type {((inputs?: Options_Backup_Save_Settings_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Backup_Save_Settings_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_backup_save_settings_label(inputs)
	if (locale === "de") return de_options_backup_save_settings_label(inputs)
	if (locale === "it") return it_options_backup_save_settings_label(inputs)
	if (locale === "ru") return ru_options_backup_save_settings_label(inputs)
	if (locale === "es") return es_options_backup_save_settings_label(inputs)
	if (locale === "zh-CN") return zh_cn2_options_backup_save_settings_label(inputs)
	if (locale === "ja") return ja_options_backup_save_settings_label(inputs)
	if (locale === "hi") return hi_options_backup_save_settings_label(inputs)
	if (locale === "pt-PT") return pt_pt2_options_backup_save_settings_label(inputs)
	return en_options_backup_save_settings_label(inputs)
});